<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "BranchIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
